import React from 'react';
import OfferReviewDetails from "./OfferReviewDetails";
import { useLocation } from "react-router-dom";
import SellerLayout from '../SellerLayout';

const OfferReview = () => {
    const location = useLocation();
    const { id } = location.state || {};

    return (
        <SellerLayout>
            <OfferReviewDetails id={id} />
        </SellerLayout>
    );
};

export default OfferReview;
